import type {
  StatsWindow,
  TemplateGoal,
  TemplateNiche,
  TemplateStatus,
} from '@/services/formTemplates';

// Mirror of back-end-next/src/lib/form-templates/constants.ts (order, labels and limits);
// template-labels.test.ts fails on drift.

export const TEMPLATE_NICHES: readonly TemplateNiche[] = [
  'home_services',
  'finance_insurance',
  'health',
  'marketing',
  'real_estate',
  'staffing',
  'b2b_services',
  'coaching',
  'fitness',
  'med_spa',
  'dental',
  'legal',
  'tutoring',
  'other',
];

export const TEMPLATE_GOALS: readonly TemplateGoal[] = ['book_calls', 'capture_leads', 'qualify'];

export const TEMPLATE_STATUSES: readonly TemplateStatus[] = ['draft', 'published', 'archived'];

export const STATS_WINDOWS: readonly StatsWindow[] = [30, 90, 365];

const STATS_PERIOD_LABELS: Record<StatsWindow, string> = { 30: '1M', 90: '3M', 365: '12M' };

/** The period pills of the Templates pages, for the shared DashboardDateRangePicker: the value is the days. */
export const STATS_PERIOD_OPTIONS: readonly { label: string; value: string }[] = STATS_WINDOWS.map((days) => ({
  label: STATS_PERIOD_LABELS[days],
  value: String(days),
}));

export const NICHE_LABELS: Record<TemplateNiche, string> = {
  home_services: 'Home services',
  finance_insurance: 'Finance & insurance',
  health: 'Health & therapy',
  marketing: 'Marketing agencies',
  real_estate: 'Real estate',
  staffing: 'Staffing & recruiting',
  b2b_services: 'Business services',
  coaching: 'Coaching',
  fitness: 'Fitness',
  med_spa: 'Med spa',
  dental: 'Dental',
  legal: 'Legal',
  tutoring: 'Tutoring',
  other: 'Other',
};

export const GOAL_LABELS: Record<TemplateGoal, string> = {
  book_calls: 'Book calls',
  capture_leads: 'Capture leads',
  qualify: 'Qualify',
};

export const STATUS_LABELS: Record<TemplateStatus, string> = {
  draft: 'Draft',
  published: 'Published',
  archived: 'Archived',
};

export const STATUS_TONES: Record<TemplateStatus, 'success' | 'info' | 'neutral'> = {
  published: 'success',
  draft: 'info',
  archived: 'neutral',
};

export const TEMPLATE_LIMITS = {
  name: 80,
  whoLine: 40,
  bookingLabel: 24,
  description: 200,
  whyLines: 3,
  whyLine: 120,
  changeNote: 200,
  evidence: 5000,
} as const;

/** The file a cover upload accepts; the server checks the same, and that it isn't animated. */
export const TEMPLATE_COVER = {
  type: 'image/webp',
  width: 1200,
  height: 900,
  maxBytes: 1_000_000,
} as const;

/** The label of a niche; an unknown niche keeps its raw value. */
export function nicheLabel(niche: string): string {
  return (NICHE_LABELS as Record<string, string | undefined>)[niche] ?? niche;
}
